module.exports = __webpack_public_path__ + "img/Skram_Hellemyrsfolket.c66f77b6.jpg";